import { Injectable } from '@angular/core';
import {ApiService} from "../api/api.service";
import {Observable} from "rxjs/Rx";
import _omit from 'lodash/omit';
import _get from 'lodash/get';
import store from 'store';

@Injectable({
  providedIn: 'root'
})
export class UserInfoService {

  constructor(private api: ApiService) { }

  public triggerCalendarNotifications(body): Observable<any> {
    return this.api.post('/user_info/notifications', {
      body
    });
  }

  public getNewPermissions(): Observable<any> {
    return this.api.get('/user_info/common_settings', {});
  }

  public processPermissios(res: any): any {
    /**
     * Maps response fields to store keys dynamically.
     * Key: path to field in backend response
     * Value: string (store key) or object with {storeKey, omit}
     * Supports nested objects using dot notation.
     * 
     * Examples:
     * - 'autocompletes' -> 'autocomplete' (simple field, will be omitted)
     * - 'role.role_board_permissions' -> 'permissions.board' (nested object, will be omitted)
     * - 'keepField' -> {storeKey: 'keep', omit: false} (will be kept in original object)
    */

    const standAloneFields: Record<string, string | {storeKey: string, omit: boolean}> = {
      autocompletes: 'autocomplete',
      users: 'users',
      'role.role_board_permissions': {
        storeKey: 'permissions.board',
        omit: false,
      },
      'role.role_field_permissions': {
        storeKey: 'permissions.fields',
        omit: false,
      },
      'role.role_general_permissions': {
        storeKey: 'permissions.general',
        omit: false,
      },
      general_settings: {
        storeKey: 'settings.general',
        omit: false,
      },
      personal_settings: 'settings.personal',
      'role.role_settings': {
        storeKey: 'settings.role',
        omit: false,
      }
    };

    const fieldsToOmit: string[] = [];
    
    Object.entries(standAloneFields).forEach(([fieldPath, config]) => {
      const value = _get(res, fieldPath, {});
      
      // Handle both string and object configurations
      const storageKey = typeof config === 'string' ? config : config.storeKey;
      const shouldOmit = typeof config === 'string' ? true : config.omit;
      
      // Dynamically determine if this is a nested key (contains a dot)
      if (storageKey.includes('.')) {
        const [parentKey, childKey] = storageKey.split('.');
        const currentParent = store.get(parentKey) || {};
        currentParent[childKey] = value;
        store.set(parentKey, currentParent);
      } else {
        store.set(storageKey, value);
      }
      
      // Add the path to the fields to omit only if shouldOmit is true
      if (shouldOmit) {
        fieldsToOmit.push(fieldPath);
      }
    });

    // Remove stand alone fields from the original object
    const commonSettings = _omit(res, fieldsToOmit);
    store.set('common_settings', commonSettings);
  }
}
